// app/javascript/components/shared/ui/TreeGuides.js
//
// Tree lines in front of a nested row, one slot per level: a 22 px toggle and
// its gap. The slots stretch to the row's height: padding the row breaks the lines.
import React from "react"
import clsx from "clsx"

export const TREE_INDENT = 26

const LINE = "absolute left-[10px] w-px bg-slate-300"

const Slot = ({ className, children }) => (
  <span className={clsx("relative shrink-0 self-stretch flex items-center", className)} style={{ width: TREE_INDENT }}>
    {children}
  </span>
)

export const TreeTrail = ({ trail = [] }) => trail.map((carries, index) => (
  <Slot key={index}>
    {carries && <span aria-hidden="true" className={clsx(LINE, "inset-y-0")} />}
  </Slot>
))

// ├, or └ for the last row; a toggle given as children sits on the branch.
export const TreeBranch = ({ last = false, children }) => (
  <Slot>
    {children ? (
      <>
        <span aria-hidden="true" className={clsx(LINE, "top-0 h-[calc(50%_-_11px)]")} />
        {!last && <span aria-hidden="true" className={clsx(LINE, "bottom-0 h-[calc(50%_-_11px)]")} />}
        {children}
      </>
    ) : (
      <>
        {!last && <span aria-hidden="true" className={clsx(LINE, "inset-y-0")} />}
        <span
          aria-hidden = "true"
          className   = {clsx(
            "absolute left-[10px] right-0 top-0 h-1/2 border-b border-slate-300",
            last && "border-l rounded-bl-[5px]",
          )}
        />
      </>
    )}
  </Slot>
)

export const TreeStem = () => (
  <span aria-hidden="true" className={clsx(LINE, "top-[calc(50%_+_11px)] bottom-0")} />
)

// The first level draws no line, only room for its toggle.
export const TreeLead = ({ depth = 0, trail = [], last = false, toggle = null }) => (
  depth > 0 ? (
    <>
      <TreeTrail trail={[false, ...trail]} />
      <TreeBranch last={last}>{toggle}</TreeBranch>
    </>
  ) : (
    <Slot>{toggle}</Slot>
  )
)

export const trailBelow = (depth, trail, last) => (depth === 0 ? [] : [...trail, !last])
